import { Dispatch, ReactNode, SetStateAction } from 'react';
import eyeSlash from '../../assets/images/icons/eye-slash.svg';
import eye from '../../assets/images/icons/eye.svg';
import Spinner from '../Spinner';
import { Container } from './styles';

export interface FormGroupInterface {
  children: ReactNode;
  error?: string | null;
  isLoading?: boolean;
  aside?: boolean;
  padding?: number;
  isPassword?: boolean;
  isVisible?: boolean;
  setIsVisible?: Dispatch<SetStateAction<boolean>>;
}

export default function FormGroup({
  children, error, isLoading, aside, padding, isPassword, isVisible, setIsVisible
}: FormGroupInterface) {
  return (
    <Container aside={aside} padding={padding}>
      <div className="form-item">
        { children }

        {isLoading && (
          <div className="loader">
            <Spinner size={14} />
          </div>
        )}

        {(isPassword && setIsVisible) && (
          <div className="password">
            {isVisible ? (
              <img src={eye} alt="eye" onClick={() => setIsVisible(false)} />
            ) : (<img src={eyeSlash} alt="eye" onClick={() => setIsVisible(true)} />)}
          </div>
        )}
      </div>
      { error && <small>{error}</small> }
    </Container>
  );
}
